import CCText from '@/Atoms/CCText';
import {useMediaQuery} from '@/Hooks/useMediaQuery/useMediaQuery';
import CCColors from '@/Utils/CCColors';
import React from 'react';
import {TouchableOpacity, View, Image} from 'react-native';
import AntDesign from 'react-native-vector-icons/AntDesign';
import {styles} from './styles';
import Spacer from '@/Atoms/Spacer';
import {hs, vs} from '@/Utils/Dimensions';
import {MaterialCommunityIcons} from '@expo/vector-icons';

const PlayerTypeSelectionIG = ({
  playerType,
  setPlayerType,
}: {
  playerType?: 'beginner' | 'pro';
  setPlayerType: (type: 'beginner' | 'pro') => void;
}) => {
  const isMobileOrTab = useMediaQuery();
  return (
    <View style={{width: '60%'}}>
      <TouchableOpacity
        style={[
          isMobileOrTab ? styles.cardMobile : styles.card,
          playerType === 'beginner' ? styles.selectedCard : undefined,
        ]}
        onPress={() => setPlayerType('beginner')}>
        <View style={styles.cardContent}>
          <View
            style={[
              styles.textContainer,
              isMobileOrTab && styles.textContainerMobile,
            ]}>
            <MaterialCommunityIcons
              name="chess-pawn"
              size={25}
              color={CCColors?.TextColor?.Primary}
            />
            <CCText style={[styles.cardTitle]}>Teach me from scratch</CCText>
          </View>
          <Image
            source={require('@/Assets/Images/Svgs/beginIg.svg')}
            style={styles.avatar}
          />
          {/* {playerType === 'beginner' && (
            <AntDesign
              name="checkcircle"
              size={20}
              color={CCColors.Primary.Default}
              style={styles.checkmark}
            />
          )} */}
        </View>
      </TouchableOpacity>
      <Spacer spacing={vs(20)} />
      <TouchableOpacity
        style={[
          isMobileOrTab ? styles.cardMobile : styles.card,
          playerType === 'pro' ? styles.selectedCard : undefined,
        ]}
        onPress={() => setPlayerType('pro')}>
        <View style={styles.cardContent}>
          <View
            style={[
              styles.textContainer,
              isMobileOrTab && styles.textContainerMobile,
            ]}>
            <MaterialCommunityIcons
              name="chess-knight"
              size={25}
              color={CCColors?.TextColor?.Primary}
            />
            <CCText style={[styles.cardTitle]}>I know how to play</CCText>
          </View>
          <Image
            source={require('@/Assets/Images/Svgs/proIg.svg')}
            style={styles.avatar}
          />
          {/* {playerType === 'pro' && (
            <AntDesign
              name="checkcircle"
              size={20}
              color={CCColors.Primary.Default}
              style={styles.checkmark}
            />
          )} */}
        </View>
      </TouchableOpacity>
    </View>
  );
};

export default PlayerTypeSelectionIG;
